import { DELETE, GET, POST, PUT } from '@lib/data/api-types';
var API_URL = 'http://localhost:3003';
var XAPI_BASE_URL = "".concat(API_URL, "/");
var COGNITO_BASE_URL = 'https://auth.inspb2b-dev.insurance.hsbc.com.sg';

// ODS agent service gateway route for the Cognito (eB2B) path. Kept relative so the browser stays same-origin with the app via CloudFront. 
var AGENT_ODS_ROUTE_NONPROD = 'ins-digilife-sg-agent-service-eb2b-cert05-proxy/v1';
var AGENT_ODS_ROUTE_BY_ENV = {
  SIT: AGENT_ODS_ROUTE_NONPROD,
  UAT: AGENT_ODS_ROUTE_NONPROD
};
var stubUrls = function stubUrls(config) {
  // Serve stub files from the current page origin so both `start:host` (3001)
  // and `start:dev` (3003) resolve to the port the app is actually served on,
  // instead of the hard-coded API_URL host. No effect on deployed envs, whose
  // overridden URLs do not contain 'localhost' and never reach this branch.
  var stubOrigin = typeof window !== 'undefined' && window.location ? window.location.origin : API_URL;
  Object.keys(config).map(function (key) {
    if (config[key].url.indexOf('localhost') !== -1) {
      var path = config[key].url.replace(/^(https?:)?\/\/[^/]+/, '');
      config[key].url = "".concat(stubOrigin, "/sgp/stub").concat(path, ".json");
      config[key].method = GET;
    }
    return config;
  });
};
var config = {
  overview: {
    url: "".concat(XAPI_BASE_URL, "dashboard"),
    method: GET
  },
  myCustomers: {
    url: "".concat(XAPI_BASE_URL, "myCustomers"),
    method: POST
  },
  myApplications: {
    url: "".concat(XAPI_BASE_URL, "myApplications"),
    method: POST
  },
  policyInfo: {
    url: "".concat(XAPI_BASE_URL, "policyInfo"),
    method: GET
  },
  policyHolderDetails: {
    url: "".concat(XAPI_BASE_URL, "policyHolderDetailsResponse"),
    method: GET
  },
  policyDetails: {
    url: "".concat(XAPI_BASE_URL, "policyDetails"),
    method: GET
  },
  myCustomersSearch: {
    url: "".concat(XAPI_BASE_URL, "myCustomers_1"),
    method: POST
  },
  libraryDetails: {
    url: "".concat(XAPI_BASE_URL, "library"),
    method: GET
  },
  downloadDocuments: {
    url: "".concat(XAPI_BASE_URL, "libraryGetDocuments"),
    method: GET
  },
  myCampaigns: {
    url: "sgp/stub/campaigns.json",
    method: POST
  },
  campaignDocumentDownload: {
    url: "sgp/stub/campaignsDocument.json",
    method: POST
  },
  newsDetails: {
    url: "sgp/stub/news.json",
    method: GET
  },
  agentDetails: {
    url: "".concat(XAPI_BASE_URL, "agent"),
    method: GET
  },
  agentODSDetails: {
    url: "".concat(XAPI_BASE_URL, "agent"),
    method: GET
  },
  notificationPreference: {
    url: "sgp/stub/notification.json",
    method: PUT
  },
  notificationPreferenceDetails: {
    url: "sgp/stub/notification.json",
    method: GET
  },
  authCodeDetail: {
    url: "sgp/stub/authcode.json",
    method: POST
  },
  newsDocumentDownload: {
    url: "sgp/stub/newsDocument.json",
    method: POST
  },
  cognitoAuthorize: {
    method: GET,
    url: "".concat(COGNITO_BASE_URL, "/oauth2/authorize")
  },
  getAccessToken: {
    method: POST,
    url: "".concat(COGNITO_BASE_URL, "/oauth2/token")
  },
  postSalesIllustration: {
    url: "".concat(XAPI_BASE_URL, "illustrations"),
    method: POST
  }
};
if (APP_ENV === 'DIT') {
  //local environment

  config.overview.url = 'https://ins-statistics-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/statistics_details';
  config.myCustomers.url = 'https://ins-policies-detail-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/my_customer_details';
  config.myApplications.url = 'https://ins-policies-detail-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/my_application_details';
  config.policyHolderDetails.url = 'https://ins-policy-holder-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/policies/{policies}/policy_holder_details/{policy_holder_details}';
  config.policyDetails.url = 'https://ins-policy-coverage-details-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/policy_coverage_details/{policyId}';
  config.myCustomersSearch.url = 'https://ins-search-customers-detail-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/search_customer';
  config.libraryDetails.url = 'https://ins-documents-forms-search-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/documents/search';
  config.downloadDocuments.url = 'https://ins-documents-forms-retrieval-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/documents/retrieve/{documentId}';
  config.agentDetails.url = 'https://ins-get-user-profile-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/get_user_profile';
  config.notificationPreference.url = 'https://ins-update-notification-preferences-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/notificationPref';
  config.myCampaigns.url = "https://ins-campaign-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/campaigns";
  config.newsDetails.url = 'https://ins-news-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/news_details';
  config.campaignDocumentDownload.url = 'https://ins-campaign-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/get_document';
  config.newsDocumentDownload.url = 'https://ins-campaign-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/get_document';
  config.postSalesIllustration.url = 'https://ins-get-user-profile-service-1.hsbc-insh-sdpeapi-sit-sct.svc.default.shp.ape1.pre-prod.aws.cloud.hsbc/v1/illustrations';
} else {
  var namespace = '';
  // Version of the get-user-profile proxy route. SIT/UAT were moved onto the
  // dedicated Cognito (eB2B) gateway namespace, which is exposed at v1; the
  // remaining envs still use the original per-env namespace at v2.
  var version = 'v2';
  switch (APP_ENV) {
    case 'DEV':
      namespace = 'sct';
      break;
    case 'SIT':
    case 'UAT':
      // Cognito (eB2B) gateway route, provided by the platform team:
      //   https://digitaldev.api.p2g.netd2.hsbc.com.hk/ins-get-user-profile-service-eb2b-mct-proxy/v1
      // Kept relative on purpose so the browser stays same-origin with the app
      // (CloudFront fronts it) and so `toSsoUrl` can still rewrite it for SSO.
      namespace = 'eb2b-mct';
      version = 'v1';
      break;
    case 'PREPROD':
      namespace = 'cert';
      break;
    case 'PROD':
      // Cognito (eB2B) gateway route, provided by the platform team:
      //   https://rbwm-api.hsbc.com.hk/ins-get-user-profile-service-eb2b-prod-proxy/v1
      // Kept relative for the same reason as SIT/UAT (same-origin via CloudFront,
      // and so `toSsoUrl` can still rewrite it for SSO).
      namespace = 'eb2b-prod';
      version = 'v1';
      break;
  }
  var userProfileBase = '';
  if (!version) {
    userProfileBase = "/ins-get-user-profile-service-".concat(namespace, "-proxy");
  } else {
    userProfileBase = "/ins-get-user-profile-service-".concat(namespace, "-proxy/").concat(version);
  }
  config.overview.url = "".concat(userProfileBase, "/statistics_details");
  config.myCustomers.url = "".concat(userProfileBase, "/my_customer_details");
  config.myApplications.url = "".concat(userProfileBase, "/my_application_details");
  config.policyHolderDetails.url = "".concat(userProfileBase, "/policies/{policies}/policy_holder_details/{policy_holder_details}");
  config.policyDetails.url = "".concat(userProfileBase, "/policy_coverage_details/{policyId}");
  config.myCustomersSearch.url = "".concat(userProfileBase, "/search_customer");
  config.libraryDetails.url = "".concat(userProfileBase, "/documents/search");
  config.downloadDocuments.url = "".concat(userProfileBase, "/documents/retrieve/{documentId}");
  config.agentDetails.url = "".concat(userProfileBase, "/get_user_profile");
  config.agentODSDetails.url = "/".concat(AGENT_ODS_ROUTE_BY_ENV[APP_ENV] || AGENT_ODS_ROUTE_NONPROD, "/agents/");
  config.notificationPreference.url = "".concat(userProfileBase, "/notificationPref");
  config.notificationPreferenceDetails.url = "".concat(userProfileBase, "/notificationPref");
  config.myCampaigns.url = "".concat(userProfileBase, "/campaigns");
  config.authCodeDetail.url = "/secp-authorisation-authcode-sgdp-proxy/v1/oauth.jsp";
  config.newsDetails.url = "".concat(userProfileBase, "/news_details");
  config.campaignDocumentDownload.url = "".concat(userProfileBase, "/get_document");
  config.newsDocumentDownload.url = "".concat(userProfileBase, "/get_document");
  config.postSalesIllustration.url = "".concat(userProfileBase, "/illustrations");
}
stubUrls(config);
export default config;